module.exports = __webpack_public_path__ + "static/media/P_01.ff54462.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/P_01.webm
// module id = 5s2D
// module chunks = 1